export const ApplicationAdminTesting = () => {

    const handleGetToken = async () => {
        try {
            const response = await fetch('/api/skytoken'); 
        } catch (error) {
            console.error('Error fetching token:', error);
        }
    }


    return (
        <div>
            <h1>Application Admin Testing Component</h1>
            <button onClick={handleGetToken}>Get Token</button>
        </div>
    );
}